import styled from "styled-components"

export const TourItemWrapper = styled.div`
    width: 100%;
    min-height: 350px;
    height: 100%;
    border-radius: 5px;
        box-shadow: 0px 4px 8px rgb(34 24 24 / 20%);
    cursor: pointer;
    position: relative;
    &:hover .image{
        img{
            transform: translateY(-10px);
        }
    }
    .image{
        width: 100%;
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 100%;
            max-height: 240px;
            object-fit: contain;
            border-radius: 5px;
            transition: all .3s linear;
        }
    }
    .title{
        margin-top: 8px;
        h1{
            font-size: 1.0rem;
            text-align: center;
            font-weight: 500;
            color: #1c1c1c;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
        }
    }

    .price{
        position: absolute;
        top: 40px;
        left: 0;
        padding: 0 8px;
        background-color: #fb6e2e;
        border-radius: 0 4px 4px 0;
        span{
            color: #ffffff;
        }
       
    }
    .discount{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        span{
            border-radius: 12px;
            padding: 2px 5px;
            background-color: #fb6e2e;
        }
    }
`
